import { Controller } from 'stimulus';

// An equipment's maintenance row: clicking it shows or hides its recent
// history (the detail row after it). Clicks on its links, buttons, and menu
// do their own thing.
export default class extends Controller {
  toggle(event) {
    if (event.target.closest('a, button, .mt-menu, input, label')) return;

    const detail = this.element.nextElementSibling;
    if (detail && detail.classList.contains('mt-detail')) detail.classList.toggle('hidden');
  }
}
